"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallPrice = exports.Root = exports.CurrentPrice = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'baseline',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));
const CurrentPrice = exports.CurrentPrice = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['oldPriceVisible', 'size'])
})(({
  oldPriceVisible,
  theme
}) => ({
  color: oldPriceVisible ? theme.palette.offer.main : theme.palette.text.primary,
  display: 'inline-block',
  whiteSpace: 'nowrap',
  [theme.breakpoints.up('sm')]: {
    display: 'block'
  }
}));
const SmallPrice = exports.SmallPrice = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  crossedOut,
  shadowColored,
  theme
}) => ({
  color: shadowColored ? theme.palette.grey.A700 : 'inherit',
  paddingLeft: theme.spacing(1),
  textDecoration: crossedOut ? 'line-through' : 'none'
}));
